import { inject, Injectable } from '@angular/core';
import { DashboardProfileContextService } from '@rma/authentication/public/user';
import { RmaResponse } from '@rma/generic/util/http';
import { map, Observable, switchMap } from 'rxjs';

import { NotificationApiService } from '../api/notification-api.service';
import { UserNotification } from '../models/user-notifications.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly profileCtx = inject(DashboardProfileContextService);
  private readonly notificationApi = inject(NotificationApiService);

  public getNextNotification(): Observable<UserNotification | null> {
    return this.profileCtx.profileIdentifier$.pipe(
      switchMap((profileIdentifier) =>
        this.notificationApi.getNextNotification(profileIdentifier.profileType, profileIdentifier.profileCode),
      ),
      map((notification) => (notification.userNotificationId ? notification : null)),
    );
  }

  public dismissUserNotification(notificationId: number): Observable<RmaResponse> {
    return this.notificationApi.dismissNotification(notificationId);
  }

  public actionUserNotification(notificationId: number): Observable<RmaResponse> {
    return this.notificationApi.actionNotification(notificationId);
  }
}
